import {
    FETCH_BULK_PRIVACY_SUCCESS,
    FETCH_USER_PRIVACY_SUCCESS,
    SET_BULK_PRIVACY_SUCCESS,
    SET_BULK_PRIVACY_ERROR,
    SET_USER_PRIVACY_SUCCESS,
    SET_BULK_PRIVACY_START,
    SET_USER_PRIVACY_START
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    userPrivacy: {},
    userPrivacyFetching: false,
    bulkPrivacy: {},
    bulkPrivacySavedSuccessfully: null
};

export const USER_PRIVACY_SETTINGS_TYPES = {
    PROFILE: 'profilePrivacySettings',
    ACTIVITY: 'activityPrivacySettings',
    WELLNESS: 'wellnessPrivacySettings'
};

const receivedUserPrivacy = (state, action) => {
    return {
        ...state,
        userPrivacy: action.data,
        userPrivacyFetching: false
    };
};

const receivedBulkPrivacy = (state, action) => {
    return {
        ...state,
        bulkPrivacy: action.data
    };
};

const resetBulkPrivacyStatus = (state, action) => {
    return {
        ...state,
        bulkPrivacySavedSuccessfully: INITIAL_STATE.bulkPrivacySavedSuccessfully
    };
};
const setBulkPrivacySuccess = (state, action) => {
    return {
        ...state,
        bulkPrivacySavedSuccessfully: true
    };
};

const setBulkPrivacyError = (state, action) => {
    return {
        ...state,
        bulkPrivacySavedSuccessfully: false
    };
};

const startUserPrivacy = (state, action) => {
    return {
        ...state,
        userPrivacyFetching: true
    };
};

const handlers = {
    [FETCH_USER_PRIVACY_SUCCESS]: receivedUserPrivacy,
    [SET_USER_PRIVACY_SUCCESS]: receivedUserPrivacy,
    [FETCH_BULK_PRIVACY_SUCCESS]: receivedBulkPrivacy,
    [SET_BULK_PRIVACY_START]: resetBulkPrivacyStatus,
    [SET_BULK_PRIVACY_SUCCESS]: setBulkPrivacySuccess,
    [SET_BULK_PRIVACY_ERROR]: setBulkPrivacyError,
    [SET_USER_PRIVACY_START]: startUserPrivacy
};

export const userPrivacyWithCustomValues = (state) => state.customUserPrivacy.userPrivacy;
export const getActivityPrivacyCategoryAccessRule = (state) => {
    return getPrivacyCategoryAccessRule(state, 'ACTIVITY');
};
export const getProfilePrivacyCategoryAccessRule = (state) => {
    return getPrivacyCategoryAccessRule(state, 'PROFILE');
};
export const getWellnessPrivacyCategoryAccessRule = (state) => {
    return getPrivacyCategoryAccessRule(state, 'WELLNESS');
};
export const getPrivacyCategoryAccessRule = (state, type) => {
    const privacyType = USER_PRIVACY_SETTINGS_TYPES[type] || USER_PRIVACY_SETTINGS_TYPES.ACTIVITY;
    return (
        state.customUserPrivacy.userPrivacy &&
        state.customUserPrivacy.userPrivacy[privacyType] &&
        state.customUserPrivacy.userPrivacy[privacyType].categoryDetails &&
        state.customUserPrivacy.userPrivacy[privacyType].categoryDetails.categoryAccessRule &&
        state.customUserPrivacy.userPrivacy[privacyType].categoryDetails.categoryAccessRule
    );
};
export const getActivitySubcategoryPrivacySettings = (state) => {
    return getSubcategoryPrivacySettings(state, 'ACTIVITY');
};
export const getProfileSubcategoryPrivacySettings = (state) => {
    return getSubcategoryPrivacySettings(state, 'PROFILE');
};
export const getWellnessSubcategoryPrivacySettings = (state) => {
    return getSubcategoryPrivacySettings(state, 'WELLNESS');
};
export const getSubcategoryPrivacySettings = (state, type) => {
    const privacyType = USER_PRIVACY_SETTINGS_TYPES[type] || USER_PRIVACY_SETTINGS_TYPES.ACTIVITY;
    return (
        state.customUserPrivacy.userPrivacy &&
        state.customUserPrivacy.userPrivacy[privacyType] &&
        state.customUserPrivacy.userPrivacy[privacyType].subcategoryPrivacySettings
    );
};
export const userPrivacyWithCustomValuesIsFetching = (state) => state.userPrivacyFetching;
export const getBulkPrivacyValues = (state) => state.customUserPrivacy.bulkPrivacy;
export const getBulkPrivacySaveSuccessStatus = (state) => state.customUserPrivacy.bulkPrivacySavedSuccessfully;

export default function customUserPrivacy(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
